import {
  privacySettingsSchema,
  type PrivacySettings,
  type UpdatePrivacySettingsInput,
} from '@teentack/shared';
import { apiFetch } from '@/lib/api-client';

/**
 * A guardian's privacy choices. [Parent steps 3, 11, 27]
 *
 * Guardian-only on the server, so these are never called for a teen or an
 * employer — the settings page that uses them only renders for a parent.
 */
export async function fetchPrivacySettings(): Promise<PrivacySettings> {
  return privacySettingsSchema.parse(await apiFetch<unknown>('/privacy'));
}

export async function savePrivacySettings(
  input: UpdatePrivacySettingsInput,
): Promise<PrivacySettings> {
  return privacySettingsSchema.parse(
    await apiFetch<unknown>('/privacy', { method: 'PATCH', body: JSON.stringify(input) }),
  );
}
